import {
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from '@/view/components/ui/alert-dialog'
import { Button } from '@/view/components/ui/button'
import { PartnerType } from '@/app/utils/partners.enum'
import { useEnableAndDisablePartnersController } from './useEnableAndDisablePartnersController'

interface EnableAndDisablePartnersProps {
  isActive: boolean
  id: PartnerType
}

export const EnableAndDisablePartners = ({
  isActive,
  id,
}: EnableAndDisablePartnersProps) => {
  const { handleConfirm, isPending } = useEnableAndDisablePartnersController({
    isActive,
    id,
  })

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <AlertDialogContent className="w-96">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Você quer realmente {isActive ? 'desabilitar' : 'habilitar'} essa
            tabela?
          </AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex items-center">
          <AlertDialogCancel disabled={isPending}>Cancelar</AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              type="button"
              onClick={handleConfirm}
              disabled={isPending}
              className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
            >
              {isPending
                ? 'Salvando...'
                : isActive
                  ? 'Desabilitar'
                  : 'Habilitar'}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </div>
  )
}
